module.exports = __webpack_public_path__ + "img/162084.612fa5f6.jpg";